import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border-left: 1px solid #CFEAF1;
  padding-left: 32px;
  padding-right: 16px;
`;

export const BannerRight = ({ children, variant }) => (
  <RightContainer className="banner-right-container">
    {children}
  </RightContainer>
);

BannerRight.propTypes = {
  children: PropTypes.node.isRequired,
}